import React from 'react'; 

import PageIntroduction from './PageIntroduction';
import PageMentions from './PageMentions';
import PageProcesses from './PageProcesses';
import PageSplash from './PageSplash';
import PageWhoAreWe from './PageWhoAreWe';

import PageProjects from './PageProjects';

import PageContact from './PageContact';

import WithConsumer from '../../context/WithConsumer';


const PageBlock = ({index,context}) => {
 	
 	if (context.posts) {
	 	
    	const posts 		= () => context.posts;
		const post 			= posts()[0];
		const block 		= post.block[index]; 
		    
		let content = '';
		
		if (block.type == 'introduction') {
		    content = <PageIntroduction block={block} />
		} else if (block.type == 'mentions') {
			content = <PageMentions block={block} />
		} else if (block.type == 'process') {
			content = <PageProcesses block={block} />
		} else if (block.type == 'splash') {
			content = <PageSplash block={block} />
		} else if (block.type == 'who_are_we') {
			content = <PageWhoAreWe block={block} />
		} else if (block.type == 'projects') {
			content = <PageProjects block={block} />
		} else if (block.type == 'contact') {
			content = <PageContact block={block} post={post} />
		}
    
		return content;
		
    } else {
	    
	    return null;
	    
    }

    

};
export default WithConsumer(PageBlock);